(function () {
  'use strict';

  var COOKIE_NAME = 'montroyal_consent';
  var COOKIE_DAYS = 365;
  var CURRENT_VERSION = 1;

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = '; expires=' + date.toGMTString();
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  function readConsent() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.v === CURRENT_VERSION) return parsed;
    } catch (_) {}
    return null;
  }

  function writeConsent(prefs) {
    var value = {
      v: CURRENT_VERSION,
      timestamp: new Date().toISOString(),
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing
    };
    setCookie(COOKIE_NAME, JSON.stringify(value), COOKIE_DAYS);
    return value;
  }

  function applyShopifyConsent(prefs) {
    function pushConsent() {
      if (!(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function')) {
        console.warn('[cookie-banner] Shopify Customer Privacy API indisponible — consentement non propagé.');
        return;
      }
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!prefs.analytics,
          marketing: !!prefs.marketing,
          preferences: !!prefs.analytics,
          sale_of_data: false
        }, function (err) {
          if (err) console.warn('[cookie-banner] Shopify consent error:', err);
        });
      } catch (e) {
        console.warn('[cookie-banner] Failed to set Shopify consent:', e);
      }
    }
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      pushConsent();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          console.warn('[cookie-banner] loadFeatures a échoué :', error);
          return;
        }
        pushConsent();
      });
    } else {
      console.warn('[cookie-banner] Shopify.loadFeatures indisponible — consentement non propagé.');
    }
    document.dispatchEvent(new CustomEvent('montroyal:consent-updated', { detail: prefs }));
  }

  function showBanner(banner) {
    banner.hidden = false;
    banner.setAttribute('data-state', 'open');
  }

  function hideBanner(banner) {
    banner.hidden = true;
    banner.removeAttribute('data-state');
  }

  function openCustomize(banner, prefs) {
    var customize = banner.querySelector('[data-cookie-customize]');
    if (!customize) return;
    customize.hidden = false;
    var analytics = customize.querySelector('[data-cookie-category="analytics"]');
    var marketing = customize.querySelector('[data-cookie-category="marketing"]');
    if (analytics) analytics.checked = !!(prefs && prefs.analytics);
    if (marketing) marketing.checked = !!(prefs && prefs.marketing);
  }

  function closeCustomize(banner) {
    var customize = banner.querySelector('[data-cookie-customize]');
    if (customize) customize.hidden = true;
  }

  function init() {
    var banner = document.getElementById('montroyal-cookie-banner');
    if (!banner) return;

    var existing = readConsent();
    if (existing) {
      applyShopifyConsent(existing);
      return;
    }

    showBanner(banner);

    banner.addEventListener('click', function (e) {
      var target = e.target.closest('[data-cookie-action]');
      if (!target) return;
      var action = target.getAttribute('data-cookie-action');

      if (action === 'accept-all') {
        var prefs = writeConsent({ analytics: true, marketing: true });
        applyShopifyConsent(prefs);
        hideBanner(banner);
      } else if (action === 'reject') {
        var prefs2 = writeConsent({ analytics: false, marketing: false });
        applyShopifyConsent(prefs2);
        hideBanner(banner);
      } else if (action === 'customize-open') {
        openCustomize(banner, existing);
      } else if (action === 'customize-cancel') {
        closeCustomize(banner);
      } else if (action === 'customize-save') {
        var an = banner.querySelector('[data-cookie-category="analytics"]');
        var mk = banner.querySelector('[data-cookie-category="marketing"]');
        var prefs3 = writeConsent({
          analytics: an && an.checked,
          marketing: mk && mk.checked
        });
        applyShopifyConsent(prefs3);
        hideBanner(banner);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
